import { Extension } from '@tiptap/core'
import { TextSelection } from 'prosemirror-state'

export const NextPlaceholder = Extension.create({
  name: 'next_placeholder',

  addKeyboardShortcuts() {

    const move = (direction) => {
      const editor = this.editor
      const { state, view } = editor
      const { doc, selection } = state

      // If user currently has *** selected, move past it (or before it)
      const anchor =
        direction > 0
          ? Math.max(selection.from, selection.to) // search forward starting after current selection
          : Math.min(selection.from, selection.to) // search backward ending before current selection

      let found = null

      // Collect all occurrences of '***' (simple + reliable)
      const hits = []
      doc.descendants((node, pos) => {
        if (!node.isText) return

        const text = node.text || ''
        let idx = 0

        while (true) {
          const i = text.indexOf('***', idx)
          if (i === -1) break

          hits.push({ from: pos + i, to: pos + i + 3 })
          idx = i + 3
        }
      })

      if (!hits.length) return false

      if (direction > 0) {
        // Next: first hit strictly after anchor
        found = hits.find(h => h.from > anchor)
        // wrap
        if (!found) found = hits[0]
      } else {
        // Prev: last hit strictly before anchor
        for (let i = hits.length - 1; i >= 0; i--) {
          if (hits[i].to < anchor) {
            found = hits[i]
            break
          }
        }
        // wrap
        if (!found) found = hits[hits.length - 1]
      }

      if (!found) return false

      const tr = state.tr.setSelection(TextSelection.create(doc, found.from, found.to))
      view.dispatch(tr)
      view.focus()

      // Scroll into view properly (DOM coords + window/container)
      requestAnimationFrame(() => {
        try {
          const start = view.coordsAtPos(found.from)
          const end = view.coordsAtPos(found.to)

          const x = (start.left + end.right) / 2
          const y = (start.top + end.bottom) / 2

          // Find nearest scrollable parent; if none, use window
          const scrollParent = (el) => {
            let cur = el
            while (cur && cur !== document.body) {
              const style = window.getComputedStyle(cur)
              const overflowY = style.overflowY
              if (overflowY === 'auto' || overflowY === 'scroll') return cur
              cur = cur.parentElement
            }
            return null
          }

          const container = scrollParent(view.dom)

          // Adjust for your sticky toolbar height (tweak if needed)
          const STICKY_OFFSET = 150

          if (container) {
            const crect = container.getBoundingClientRect()
            const targetTop = (y - crect.top) + container.scrollTop - STICKY_OFFSET

            container.scrollTo({
              top: targetTop,
              behavior: 'smooth',
            })
          } else {
            window.scrollTo({
              top: window.scrollY + y - STICKY_OFFSET,
              behavior: 'smooth',
            })
          }
        } catch (e) {
          // coordsAtPos can throw if selection is weird; ignore
        }
      })

      return true
    }

    return {
      Tab: () => move(+1),
      'Shift-Tab': () => move(-1),
    }
  },
})
